import './switch.less';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	isActive: PropTypes.bool,
	onSwitch: PropTypes.func
};

const Switch = ({ isActive, onSwitch }) => (
	<span className={cn('action-switch-control', isActive && 'action-switch-control--active')} onClick={onSwitch} />
);

Switch.propTypes = propTypes;
export default Switch;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/switch.js